import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { DocumentoOficialResponse } from '../models/documento-oficial.model';
import { BehaviorSubject } from 'rxjs';
import { DocumentoGenerado } from '../../bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';

@Injectable({providedIn: 'root'})
export class DetalleDocumentosOficialesService {
    documentoOficial:BehaviorSubject<DocumentoGenerado>= new BehaviorSubject<DocumentoGenerado>(null)

    get documentoOficial$(){
        return this.documentoOficial.asObservable()
    }

    constructor(private apiService: ApiService) { }

    getListaDocumentoOficial(documento_uuid:string){
        const url=`/documento_generado/${documento_uuid}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los datos.')
                .subscribe((response: DocumentoOficialResponse) => {
                    this.documentoOficial.next(response.data)
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }
    
    
}